<template>
  <div>
    <v-sheet
      v-if="!categorie.length"
      :color="`grey`"
      class="pa-3"
    >
      <v-skeleton-loader
        class="mx-auto"
        type="text-field, table, data-table"
      >
      </v-skeleton-loader>
    </v-sheet>
    <v-card v-else>
      <snack-view
        :message="snackbar.message"
        :activate="snackbar.active"
        :bg-color="snackbar.color"
      ></snack-view>
      <div>
        <v-card-title class="text-uppercase font-weight-bold">
          Liste des catégories
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              offset-md="8"
              md="4"
            >
              <v-text-field
                v-model="search"
                :append-icon="icons.mdiMagnify"
                label="Rechercher"
                single-line
                hide-details
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="categorie"
          :search="search"
          :options="dataOptions"
          :items-per-page="15"
          sort-by="id"
          class="table-kitchen-sink"
        >
          <!-- product -->
          <template #[`item.name`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <span class="d-block font-weight-semibold text-truncate text--primary"><v-icon>{{ item.icon }}</v-icon>  {{ item.name }}</span>
              </div>
            </div>
          </template>

          <template #[`item.id`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <span class="d-block font-weight-semibold text-truncate text--primary">{{ categorie.indexOf(item) + 1 }}</span>
              </div>
            </div>
          </template>

          <template #[`item.departement`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <span class="d-block font-weight-semibold text-truncate text--primary">{{ nomDepartement(item.departement_id) }}</span>
              </div>
            </div>
          </template>

          <template #[`item.created_at`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <span class="d-block font-weight-semibold text-truncate text--primary">{{ moment(item.created_at).format('D MMMM YYYY')  }}</span>
              </div>
            </div>
          </template>

          <template #[`item.updated_at`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <span class="d-block font-weight-semibold text-truncate text--primary">{{ moment(item.updated_at).format('D MMMM YYYY')  }}</span>
              </div>
            </div>
          </template>

          <template #[`item.state`]="{item}">
            <div class="d-flex align-center">
              <div class="d-flex flex-column ms-3">
                <v-chip
                  v-if="item.state==1"
                  class="ma-2 text-center pr-5 pl-5"
                  color="#F1FFE8FF"
                >
                  <b class="success--text">actif</b>
                </v-chip>
                <v-chip
                  v-else
                  class="ma-2 text-center pr-5 pl-5"
                  color="#ffcfcf"
                >
                  <b class="error--text">bloqué</b>
                </v-chip>
              </div>
            </div>
          </template>

          <!-- action -->
          <template #[`item.actions`]="{ item }">
            <div class="col-12 w-">
              <v-btn
                outlined
                x-small
                color="info"
                @click="editItem(item)"
              >
                <v-icon
                  x-small
                  class="me-2"
                >
                  {{ icons.mdiPencilOutline }}
                </v-icon>
                Modifier
              </v-btn>
            </div>
          </template>
        </v-data-table>

        <!-- dialog édition -->
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span>Modifier une categorie</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <v-form
                  ref="updatePermCatForm"
                >
                <v-row>
                  <v-col
                    cols="12"
                      offset-md="2"
                      md="8"
                    >
                      <v-select
                        v-model="editedItem.departement_id"
                        outlined
                        dense
                        :items="departements"
                        :rules="LocalNameRules"
                        item-text="name"
                        item-value="id"
                        label="Département"
                        class="mb-n6"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      offset-md="2"
                      md="8"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                        label="Nom"
                        :rules="LocalNameRules"
                      outlined
                      dense
                        placeholder="Nom"
                        hide-details="auto"
                    ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      offset-md="2"
                      md="8"
                    >
                      <v-text-field
                        v-model="editedItem.icon"
                        label="Icone"
                        :rules="LocalNameRules"
                      outlined
                      dense
                        placeholder="Icone"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      offset-md="2"
                      md="8"
                      class="pr-0 mt-n8 pb-10"
                    >
                      <div
                        class="d-flex flex-row align-items-end"
                      >
                        <h3 class="mt-5 mr-2 font-weight-light">
                          <span>Etat </span>
                        </h3>
                        <v-switch
                          v-model="editedItem.status"
                          inset
                          color="success"
                        >
                          <template v-slot:label>
                            <span :class="editedItem.status?'success--text':'error--text'">
                              {{ editedItem.status?'actif':'bloqué' }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                  </v-col>
                </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                outlined
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                color="primary"
                @click="save"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialog suppression -->
        <v-dialog
          v-model="dialogDelete"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Are you sure you want to delete this item?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                outlined
                @click="closeDelete"
              >
                Cancel
              </v-btn>
              <v-btn
                color="success"
                @click="deleteItemConfirm"
              >
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
import { onBeforeMount, ref } from '@vue/composition-api'
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiEyeOutline,
} from '@mdi/js'
import data from '@/views/locaux/datatable'
import Http from '@/helpers/http'
import Vue from 'vue'
import moment from 'moment'
// eslint-disable-next-line import/extensions
import SnackView from '@/views/SnackView'

Vue.prototype.moment = moment

export default {
  components: {
    SnackView,
  },
  setup() {
    const search = ref('')
    const categorie = ref([])
    const departements = ref([])
    const snackbar = ref({
      active: false,
      message: '',
      color: 'success',
    })

    // Règle de validation d'un champ
    const LocalNameRules = [
      v => !!v || 'Ce champ est réquis',
    ]

    const getDepartement = () => {
      Http.get('departement')
        .then(response => {
          // eslint-disable-next-line no-multi-assign
          departements.value = response.data
          console.log('departement')
          console.log(departements.value)
        })
    }

    const nomDepartement = id => {
      // eslint-disable-next-line array-callback-return,no-return-assign
      let name = departements.value.filter(item => name = item.id === id)
      if (name.length === 1) return name[0].name

      return id
    }

    const loadPermissionCategories = () => {
      getDepartement()
      Http.get('permission-categorie')
        .then(async response => {
          categorie.value = await response.data
        })
        .catch(error => {
          console.error('Erreur :', error)
        })
    }

    onBeforeMount(() => {
      loadPermissionCategories()
    })

    return {
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiEyeOutline,
      },
      search,
      getDepartement,
      nomDepartement,
      headers: [
        { text: 'N°', value: 'id', divider: true },
        { text: 'Nom', value: 'name', divider: true },
        { text: 'Icone', value: 'icon', divider: true },
        { text: 'Departement', value: 'departement', divider: true },
        { text: 'Etat', value: 'state', divider: true },
        { text: 'Date de création', value: 'created_at', divider: true },
        { text: 'Dernière MAJ', value: 'updated_at', divider: true },
        {
          text: 'Actions', value: 'actions', sortable: false, divider: true,
        },
      ],
      dataOptions: {
        sortBy: ['id'],
      },
      categorie,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      dialog: false,
      dialogDelete: false,
      departements,
      snackbar,
      LocalNameRules,
      loadPermissionCategories,
    }
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
    dialogDelete(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.closeDelete()
    },
  },
  mounted() {
    moment.locale('fr')
  },
  methods: {
    initialize() {
      this.userList = JSON.parse(JSON.stringify(data))
    },

    editItem(item) {
      console.log(item)
      this.editedIndex = this.categorie.indexOf(item)
      // eslint-disable-next-line no-param-reassign
      item.status = item.state === 1
      this.editedItem = { ...item }
      this.dialog = true
    },

    deleteItem(item) {
      this.editedIndex = this.categorie.indexOf(item)
      this.editedItem = { ...item }
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.categorie.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    save() {
      if (this.$refs.updatePermCatForm.validate()) {
        this.snackbar.active = false
        this.editedItem.state = this.editedItem.status ? 1 : -1
        Http.put(`/permission-categorie/${this.editedItem.id}`, { departement_id: this.editedItem.departement_id, name: this.editedItem.name, icon: this.editedItem.icon,state:this.editedItem.state })
        .then(response => {
            if (response.status === 201) {
              this.loadPermissionCategories()
              this.snackbar.message = response.message
              this.snackbar.active = true
            }
        })
        .catch(error => {
          console.log(error)
        })

      this.close()
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
